export default "__VITE_ASSET__Dc$Lzzgr__"